import './videoTelematicsFilter.css';
import Checkbox from "../../../shared/checkbox/checkbox";
const VideoTelematicsFilter = () => {
    return(
        <ul className={'filter-list round-corner-8'}>
            <li>
                <div className="filter-title">Category</div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Road Alerts</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Cabin Alerts</label>
                </div>
            </li>
            <li>
                <div className="filter-title">Select Group</div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Group 1</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Group 2</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={false}/>
                    <label className={'margin-l-10'}>Group 3</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Group 4</label>
                </div>
            </li>
            <li>
                <div className="filter-title margin-b-15">Vehicles</div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 05 HJ 1890</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 06 HJ 1360</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 07 HJ 2890</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 02 HJ 7830</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 05 HJ 1890</label>
                </div>
            </li>
            <li>
                <div className="filter-title">Alerts</div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>FCW</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>PCW</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Drowsy</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>HWM</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>HA</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>HB</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Stressed</label>
                </div>
            </li>
            {/*<li>*/}
            {/*    <div className="filter-title">Location (State)</div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>AP</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Assam</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Chandigharh</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Delhi</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Gujarat</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Karnataka</label>*/}
            {/*    </div>*/}
            {/*</li>*/}
        </ul>
    )
}

export default VideoTelematicsFilter;
